module.exports = __webpack_public_path__ + "static/media/quickswap-logo.c3d21c44.zip";